<template>
  <no-ssr>
    <Drawer :title="drawerTitle" width="680" @on-close="closeMessage" v-model="visable">
      <spinner v-model="loading"></spinner>
      <skeleton-paragraph v-if="spinnerShow" :lines="9"/>
      <div style="height: 100%" v-else>
        <div class="drawer-content" style="margin:auto 40px">
          <Form @submit.native.prevent ref="userForm" label-position="top" :model="userForm" :rules="rules">
            <FormItem label="通知标题" prop="msgTitle">
              <Input
                placeholder="请输入通知标题"
                v-model="userForm.msgTitle"
                :maxlength="20"
                :readonly="readonly"
              />
            </FormItem>
            <FormItem label="通知内容" prop="msgContext">
              <Input
                v-model="userForm.msgContext"
                type="textarea"
                :maxlength="500"
                :autosize="{minRows: 20}"
                :readonly="readonly"
              />
            </FormItem>
            <FormItem label="发信人" v-if="isAdmin == 1" prop="userids">
              <Input type="textarea" :rows="4" v-model="userForm.userids" :readonly="true"/>
            </FormItem>
          </Form>
        </div>
        <div class="drawer-footer">
          <Button type="primary" @click="adminSendMessage4Add(0)" v-if="saveBtn">保存</Button>
          <Button type="primary" @click="sendUserModal=true" v-if="saveBtn">发送至</Button>
          <Button type="primary" @click="adminUpdateMessage(0)" v-if="editBtn">保存</Button>
          <Button type="primary" @click="sendUserModal=true" v-if="editBtn">发送至</Button>
        </div>
      </div>
      <Modal
        v-model="sendUserModal"
        title="选择发送人"
        @on-ok="ok"
        :mask-closable="false"
        :closable="false"
        width="600"
      >
        <el-tree
          class="my-tree"
          ref="orgTree"
          show-checkbox
          @check="check"
          :data="orgTree"
          style="height:400px;overflow-y:scroll"
        >
          <template slot-scope="{ node, data }">
            <div style="width: 100%">{{data.label}}</div>
          </template>
        </el-tree>
      </Modal>
    </Drawer>
  </no-ssr>
</template>
<script>
import Format from "~/plugins/format.js";
export default {
  // name: "dictionary-item-drawer",
  props: {},
  data() {
    return {
      treeData: [
        {
          title: "parent",
          loading: false,
          children: []
        }
      ],
      message: [],
      readonly: true,
      userForm: {},
      sendUserModal: false,
      visable: false,
      spinnerShow: false,
      loading: false,
      drawerTitle: null,
      saveBtn: true,
      editBtn: true,
      isAdmin: null,
      orgNameArr: "",
      messageID: 0,
      messageIds: [],
      rules: {
        msgTitle: [
          {
            required: true,
            message: "通知标题不能为空",
            trigger: "blur"
          }
        ],
        msgContext: [
          {
            required: true,
            message: "通知内容不能为空",
            trigger: "blur"
          }
        ],
        userids: [
          {
            required: true,
            message: "发送人不能为空",
            trigger: "blur"
          }
        ]
      }
    };
  },
  mounted() {
    this.treeLoadNode();
  },
  methods: {
    treeLoadNode() {
      this.$store.dispatch("org/findOrgTreeByCurrentUser").then(res => {
        this.orgTree = res;
      });
    },
    enter(node) {
      this.$set(node, "$enter", true);
    },
    leave(node) {
      this.$set(node, "$enter", false);
    },
    treeNodeClick(node, data) {
      this.search = {};
      this.search.queryType = 0;
      this.treeNodeChange(node);
    },
    treeNodeChange(node) {
      if (this.nextTreeNodeKey && this.nextTreeNodeKey != node.key) {
        let nextNode = this.$refs.orgTree.getNode(this.nextTreeNodeKey);
        this.$set(nextNode, "$select", false);
      }
      this.nextTreeNodeKey = node.key;
      this.$set(node, "$select", true);
    },
    check(checkedNodes, checkedKeys) {
      this.message = [];
      this.messageIds = [];
      var checkedNodes = checkedKeys.checkedNodes;
      for (let i = 0; i < checkedNodes.length; i++) {
        this.message.push(checkedNodes[i].value);
        this.messageIds.push(checkedNodes[i].value);
        this.orgNameArr = this.message.join(",");
      }
    },
    ok() {
      let admin = this.message;
      if (admin.length == 1) {
        this.userForm.userids = admin.join("");
      } else {
        var adminName = "";
        for (let i = 0; i < admin.length; i++) {
          adminName += admin[i] + ", ";
        }
        adminName = adminName.substring(0, adminName.lastIndexOf(","));
        this.userForm.userids = adminName;
      }
      this.adminSendMessage4Add(1);
    },
    addMessage() {
      this.drawerTitle = "新建通知消息";
      this.visable = true;
      this.readonly = false;
      this.saveBtn = true;
      this.editBtn = false;
      this.userForm = {
        msgTitle: "",
        msgContext: "",
        userids: ""
      };
    },
    updateMessage(msgID, type, edit, number, isAdmin, status) {
      
      this.visable = true;
      this.loading = true;
      this.isAdmin = isAdmin;
      this.spinnerShow = true;
      if (edit) {
        this.readonly = false;
        this.drawerTitle = "编辑通知消息";
        this.saveBtn = false;
        this.editBtn = true;
        this.messageID = msgID;
      } else {
        this.readonly = true;
        this.drawerTitle = "查看通知消息";
        this.saveBtn = false;
        this.editBtn = false;
      }
      if (isAdmin == 1) {
        this.$store
          .dispatch("message/updateMessagesServiceStatus", {
            //更改读取状态
            messageId: msgID,
            messageType: type
          })
          .then(res => {
            this.$root.$emit("messageNoticeCount")
            this.getMessage(msgID, type, number, isAdmin, status);
          })
          .catch(error => {
            this.$Message.warning(error.message);
          });
      } else {
        this.getMessage(msgID, type, number, isAdmin, status);
      }
    },
    adminUpdateMessage(num) {
      //编辑中保存发送消息
      this.$refs["userForm"].validate(valid => {
        if (valid) {
          this.loading = true;
          this.$store
            .dispatch("message/adminSendMessage", {
              type: num,
              messageTitle: this.userForm.msgTitle,
              receiveUserId: this.userForm.userids,
              messageContext: this.userForm.msgContext,
              messageId: this.messageID,
              orgIdArr: this.messageIds,
              orgNameArr: this.orgNameArr,
              saveTime: this.resData.saveTime
            })
            .then(res => {
              this.loading = false;
              this.$emit("tableReload");
              this.$Message.success("操作成功");
              this.visable = false;
            })
            .catch(error => {
              this.loading = false;
              this.$Message.warning(error.message);
            });
        }
      });
    },
    adminSendMessage4Add(num) {
      //新建中保存发送消息
      
      if ((num == 1 && this.userForm.userids !== "") || num == 0) {
        this.$refs["userForm"].validate(valid => {
          if (valid) {
            this.loading = true;
            this.$store
              .dispatch("message/adminSendMessage", {
                type: num,
                messageTitle: this.userForm.msgTitle,
                receiveUserId: this.userForm.userids,
                messageContext: this.userForm.msgContext,
                orgIdArr: this.messageIds,
                orgNameArr: this.orgNameArr,
                messageId: this.messageID
              })
              .then(res => {
                this.loading = false;
                this.$emit("tableReload");
                this.$Message.success("操作成功");
                this.visable = false;
              })
              .catch(error => {
                this.loading = false;
                this.$Message.warning(error.message);
              });
          }
        });
      } else {
        this.$refs["userForm"].validate(valid => {
          if (valid) {
          }
        });
      }
    },
    getMessage(msgID, type, number, isAdmin, status) {
      let resData = {};
      if (isAdmin == 1) {
        this.$store
          .dispatch("message/adminGetMessage", {
            messageId: msgID,
            pageType: number
          })
          .then(res => {
            this.resData = Object.assign({}, res);
            //赋值到form
            this.userForm.msgTitle = this.resData.messageTitle;
            this.userForm.msgContext = this.resData.messageContext;
            if (status == 1) {
              this.userForm.userids = this.resData.sendUserName;
            } else {
              this.userForm.userids = this.resData.sendUserName;
            }
            this.loading = false;
            this.spinnerShow = false;
          })
          .catch(error => {
            this.$Message.error("查看失败");
          });
      } else {
        this.$store
          .dispatch("message/adminGetMessage", {
            messageId: msgID,
            pageType: number
          })
          .then(res => {
            this.resData = Object.assign({}, res);
            //赋值到form
            this.userForm.msgTitle = this.resData.messageTitle;
            this.userForm.msgContext = this.resData.messageContext;
            if (status == 1) {
              this.userForm.userids = this.resData.orgNameArr;
            } else {
              this.userForm.userids = this.resData.orgNameArr;
            }
            this.loading = false;
            this.spinnerShow = false;
          })
          .catch(error => {
            this.$Message.error("查看失败");
          });
      }
    },
    closeMessage() {
      this.$refs["userForm"].resetFields();
      this.$emit("tableReload");
    }
  }
};
</script>

